//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import {
  mdiTrayArrowUp,
  mdiDotsVertical,
  mdiCircle,
  mdiMapMarker,
  mdiCancel,
  mdiPlay,
  mdiStarOutline,
  mdiVideo,
  mdiPencil,
  mdiMovieOpenPlayOutline,
  mdiHelpCircleOutline,
} from '@mdi/js'
import { ref, computed, watch, onMounted, onUnmounted } from '@vue/composition-api'
import { useRouter, openTab, downloadAppByOS } from '@core/utils'
import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import { avatarText } from '@core/utils/filter'
import {
  getMatchOpenCode,
  getMatchCode,
  editMatchInfo,
  joinGame,
  reportIssue,
  logUserActivity,
} from '@api'
import { success } from '@/@core/utils/toasted'
import useShare from '@/@core/utils/useShare'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import useVideoData from '@core/utils/useVideoData'
import videojs from 'video.js'

import AppBarUserMenu from '@core/layouts/components/app-bar/AppBarUserMenu.vue'
import VideoAction from '@/views/match-detail/components/video-action/VideoAction.vue'
import PlayerList from '@/views/match-detail/components/player-list/PlayerList.vue'
import OrganizerList from '@/views/match-detail/components/organizer-list/OrganizerList.vue'
import HighlightList from '@/views/match-detail/components/highlight-list/HighlightList.vue'
import SendIcon from '@/views/match-detail/components/icons/SendIcon.vue'
import FilmPlay from '@/views/match-detail/components/icons/FilmPlay.vue'
import ChangeName from '@/views/match-detail/components/change-name/ChangeName.vue'
import Report from '@/views/match-detail/components/report/Report.vue'
import MatchCard from '@/views/match-detail/components/match-card/MatchCard.vue'
import GroupList from '@/views/match-detail/components/group-list/GroupList.vue'

import useMatchDetail from './useMatchDetail'

export default {
  components: {
    AppBarUserMenu,
    VideoAction,
    PlayerList,
    OrganizerList,
    HighlightList,
    SendIcon,
    FilmPlay,
    ChangeName,
    Report,
    MatchCard,
    GroupList,
  },
  setup() {
    const { route, router } = useRouter()
    const { t } = useUtils()
    const { decryptData, userData } = useCryptoJs()
    const { logData, updateLogData, clearLogData } = useLogData()
    const { videoData, updateVideoData, clearVideoData } = useVideoData()
    const { shareURL } = useShare()
    const { paymentMethods } = useMatchDetail()

    const USER_ACT_VISIT_MATCH_LANDING_APP = 'Visit Match Landing App'
    const USER_ACT_SHARE_MATCH_LANDING_APP = 'Share Match Landing App'
    const USER_ACT_VIEW_MATCH_LANDING_APP = 'View Match Landing App'
    const ipAddress = ref({})

    const dataLanding = ref({})
    const dataComputed = computed(() => dataLanding.value)
    const activeComputed = computed(() => dataComputed.value.match_status === 'Active')
    const basicComputed = computed(() => dataComputed.value.match_status === 'Basic')
    const computedMatchCode = computed(() => JSON.parse(localStorage.getItem('matchCode')))
    const matchCode = ref(null)
    const videoId = ref(null)
    const privateLanding = ref(false)
    const isDialogChangeName = ref(false)
    const isDialogReport = ref(false)

    const playerOptions = ref({
      controls: true,
      responsive: true,
      breakpoints: true,
      fill: true,
      autoplay: false,
      muted: true,
      loop: true,
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [],
      poster: 'https://fanaty-general-ohio.s3.us-east-2.amazonaws.com/no-thumb.jpg',
      notSupportedMessage: 'Este video no está disponible temporalmente, intente nuevamente más tarde.',
      usingPlugin: true,
      fluid: true,
      aspectRatio: '16:9',
    })

    const onLogin = async (isJoinGame = 'NO') => {
      logData.value.joinGame = isJoinGame
      logData.value.matchCode = computedMatchCode.value
      logData.value.redirect = 'landing'
      logData.value.field = 'all'
      logData.value.date = 'all'
      logData.value.time = 'all'
      await updateLogData(logData.value)

      router.push({ name: 'auth-login-phone-email' })
    }

    const onJoinGame = async () => {
      if (privateLanding.value) {
        const resp = await joinGame({ match_code: computedMatchCode.value })
        if (resp.ok) {
          isDialogChangeName.value = false
          await fetchMatch()
        }
      } else onLogin('YES')
    }

    const resolvePosterIcon = status => {
      if (status === 'Active') return mdiPlay
      if (status === 'Processing') return mdiCircle
      if (status === 'Basic' || status === 'Recording') return mdiCircle
      if (status === 'Cancelled') return mdiCancel

      return mdiCircle
    }

    const resolvePosterIconColor = status => {
      if (status === 'Basic') return 'info'
      if (status === 'Active' || status === 'Premiun' || status === 'Recording' || status === 'Cancelled') return 'secondary'

      return 'secondary'
    }

    const fetchLogUserActivity = async action => {
      await logUserActivity({
        ip_address: privateLanding.value ? null : ipAddress.value.ip,
        user_id: privateLanding.value ? userData.value.user_id : null,
        match_code: matchCode.value,
        reference: null,
        action: action,
      })
    }

    const onShare = () => {
      shareURL(dataComputed.value.match_name, `${dataComputed.value.match_name}\n${dataComputed.value.match_date_str}\n\n${dataComputed.value.share_link}`, dataComputed.value.share_link)

      // fetchLogUserActivity(USER_ACT_SHARE_MATCH_LANDING_APP)
    }

    const linkVideo = status => {
      if (status && status !== 'Active') return false

      // window.open(`${window.location.origin}/app-redirect/${videoData.value.video_id}`, '_blank')
      downloadAppByOS(
        `${window.location.origin}/app-redirect/${videoId.value}`,
        `${window.location.origin}/app-redirect/${videoId.value}`,
        `${window.location.origin}/app-redirect/${videoId.value}`,
        true,
      )

      // fetchLogUserActivity(USER_ACT_VIEW_MATCH_LANDING_APP)

      return true
    }

    const openClose = async val => {
      isDialogChangeName.value = val
      if (dataComputed.value.is_organizer) isDialogChangeName.value = val
      else isDialogChangeName.value = false
    }

    const onChangeName = async val => {
      const resp = await editMatchInfo(computedMatchCode.value, { match_name: val })
      if (resp.ok) {
        isDialogChangeName.value = false
        await fetchMatch()
      }
    }

    const openCloseReport = async val => {
      isDialogReport.value = val
    }

    const onReportIssue = async (val, email) => {
      const resp = await reportIssue(matchCode.value, val)
      if (resp.ok) {
        isDialogReport.value = false
        success(resp.message)
        await fetchMatch()
      }
    }

    const fetchMatch = async () => {
      let response = null
      if (userData.value) {
        response = await getMatchCode(matchCode.value)
      } else {
        response = await getMatchOpenCode(matchCode.value)
      }

      if (response.ok) {
        dataLanding.value = response.data

        if (dataLanding.value.show_video_type) {
          videoData.value.video = null
          videoData.value.match = matchCode.value
          videoData.value.price = dataLanding.value.match_price
          videoData.value.paymentMethodsParams = paymentMethods.value
          videoData.value.landingParams = dataLanding.value
          await updateVideoData(videoData.value)

          router.push({ name: 'views-video-quality' })
        }

        if (dataLanding.value.reference) {
          const videoReference = decryptData(dataLanding.value.reference)
          if (videoReference.video_id) videoId.value = videoReference.video_id
        }

        if (dataLanding.value.match_status === 'Cancelled') {
          router.push({ name: 'video-cancelled' })
        } else {
          let player = null
          let getPlayer = videojs.getPlayer('matchRecapVideo')
          if (getPlayer) {
            const vjs = document.getElementById('matchRecapVideo')
          }

          if (!getPlayer) {
            if (dataLanding.value.thumbnail) playerOptions.value.poster = dataLanding.value.thumbnail

            // type: 'application/dash+xml',
            // src: 'https://fanaty-staging-ohio.s3.us-east-2.amazonaws.com/ticket-2118/hls/a.m3u8',
            if (dataLanding.value.match_recap_video) {
              playerOptions.value.sources.push({
                type: 'application/x-mpegURL',
                src: dataLanding.value.match_recap_video,
              })

              setTimeout(() => {
                player = videojs('matchRecapVideo', playerOptions.value)
              }, 200)
            }
          }
        }
      }
    }

    const textBreakLine = text => {
      if (text) return text.split('.').filter(e => e).map(e => (`<p class="ma-0">${e}.</p><br />`)).join('')

      return `<span></span>`
    }

    watch([route], async () => {
      const { name } = route.value

      // privateLanding.value = name === 'match'

      await fetchMatch()

      await fetch('https://api.ipify.org/?format=json')
        .then(ipResponse => ipResponse.json())
        .then(async ipData => ipAddress.value = ipData)
    })

    onMounted(async () => {
      const { name } = route.value

      // privateLanding.value = name === 'match'

      if (name === 'public') await clearLogData()
      await clearVideoData()

        const { code } = route.value.params
        // const { reauth, code } = route.value.params
        // if (reauth) window.location.reload()
        matchCode.value = code
      localStorage.setItem('matchCode', JSON.stringify(code))

      await fetchMatch()

      if (!userData.value) {
        await fetch('https://api.ipify.org/?format=json')
          .then(ipResponse => ipResponse.json())
          .then(async ipData => ipAddress.value = ipData)
      }

      // fetchLogUserActivity(USER_ACT_VISIT_MATCH_LANDING_APP)
    })

    onUnmounted(() => {
      if (videojs.getPlayer('matchRecapVideo')) videojs.getPlayer('matchRecapVideo').dispose()
    })

    return {
      // data
      USER_ACT_VISIT_MATCH_LANDING_APP,
      USER_ACT_SHARE_MATCH_LANDING_APP,
      USER_ACT_VIEW_MATCH_LANDING_APP,
      ipAddress,
      userData,

      playerOptions,
      matchCode,
      privateLanding,
      isDialogChangeName,
      isDialogReport,

      // computed
      dataComputed,
      activeComputed,
      basicComputed,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      avatarText,
      openTab,
      onLogin,
      shareURL,
      resolvePosterIcon,
      resolvePosterIconColor,
      onShare,
      linkVideo,
      fetchMatch,
      openClose,
      onChangeName,
      openCloseReport,
      onReportIssue,
      onJoinGame,
      textBreakLine,

      t,

      icons: {
        mdiTrayArrowUp,
        mdiDotsVertical,
        mdiCircle,
        mdiMapMarker,
        mdiCancel,
        mdiPlay,
        mdiStarOutline,
        mdiVideo,
        mdiPencil,
        mdiMovieOpenPlayOutline,
        mdiHelpCircleOutline,
      },
    }
  },
}
